<template>
  <Modal disable-backdrop-click v-bind="{ redirectOnClose: true }">
    <div class="modal max-w-md mx-auto" slot-scope="{ closeModal }" @click.stop>
      <div class="modal__header">
        <h6 class="heading">Edit Product</h6>
      </div>
      <div class="modal__body">
        <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
          <form class="space-y-16" @submit.prevent="handleSubmit(submit)">
            <div class="space-y-8">
              <ValidationProvider
                name="name"
                vid="name"
                rules="required"
                v-slot="{ errors, failed }"
                slim
              >
                <div class="space-y-2">
                  <label for="name" class="label"> Name * </label>
                  <input
                    id="name"
                    v-model="productData.name"
                    :disabled="updating"
                    :class="{ 'has-error': failed }"
                    type="text"
                    name="name"
                    class="input"
                    placeholder="enter name..."
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <ValidationProvider
                name="description"
                vid="description"
                v-slot="{ errors, failed }"
                slim
              >
                <div class="space-y-2">
                  <label for="description" class="label"> Description </label>
                  <textarea
                    id="description"
                    v-model="productData.description"
                    data-vv-as="description"
                    :disabled="updating"
                    name="description"
                    class="input"
                    rows="5"
                    placeholder="enter description..."
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <ValidationProvider
                name="supplementary description"
                vid="supplementaryDescription"
                v-slot="{ errors, failed }"
                slim
              >
                <div class="space-y-2">
                  <label for="supplementaryDescription" class="label">
                    Supplementary description
                  </label>
                  <textarea
                    id="supplementaryDescription"
                    v-model="productData.supplementaryDescription"
                    data-vv-as="supplementary description"
                    :disabled="updating"
                    name="supplementaryDescription"
                    class="input"
                    rows="5"
                    placeholder="enter text..."
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <ValidationProvider name="url" vid="url" v-slot="{ errors, failed }" slim>
                <div class="space-y-2">
                  <label for="url" class="label"> Url * </label>
                  <input
                    id="name"
                    v-model="productData.url"
                    :disabled="updating"
                    :class="{ 'has-error': failed }"
                    type="url"
                    name="url"
                    class="input"
                    placeholder="product presentation url"
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <div class="flex-none">
                <label class="label custom-checkbox">
                  <input
                    type="checkbox"
                    @input="productData.isBeta = $event.target.checked"
                    :checked="productData.isBeta"
                  />
                  <span />
                  <span>Beta</span>
                </label>
              </div>

              <ValidationProvider
                name="price"
                vid="price"
                rules="required|decimal:2|min_value:1"
                v-slot="{ errors, failed }"
                slim
              >
                <div class="space-y-2">
                  <label for="price" class="label"> Price * </label>
                  <input
                    id="price"
                    v-model="productData.price"
                    :disabled="updating"
                    :class="{ 'has-error': failed }"
                    type="number"
                    step="0.01"
                    name="price"
                    class="input w-32"
                    placeholder="enter price..."
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <ValidationProvider
                v-if="product.type === 'service'"
                name="produces"
                vid="producesModelType"
                :rules="producesRules"
                v-slot="{ errors, failed }"
                slim
              >
                <div class="space-y-2">
                  <label for="produces_model_type" class="label"> Produces * </label>
                  <select
                    id="produces_model_type"
                    v-model="productData.producesModelType"
                    :disabled="updating"
                    :class="{ 'has-error': failed }"
                    class="input"
                  >
                    <option value="pages">Page</option>
                    <option value="campaigns">Ad Plan</option>
                    <option value="channels">Channel</option>
                    <option value="pipelines">Pipeline</option>
                    <option value="contact-lists">Contact List</option>
                    <option value="automations">Automation</option>
                    <option value="forms">Form</option>
                    <option value="media">Creatives</option>
                  </select>
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <ValidationProvider
                name="categories"
                vid="categories"
                v-slot="{ errors, failed }"
                slim
              >
                <div class="space-y-2">
                  <label for="categories" class="label"> Categories </label>
                  <VSelect
                    v-model="productData.categories"
                    :options="categories"
                    :reduce="optionReducer"
                    :disabled="updating"
                    multiple
                    label="name"
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>

              <ValidationProvider name="tags" vid="tags" v-slot="{ errors, failed }" slim>
                <div class="space-y-2">
                  <label for="tags" class="label capitalize"> Tags </label>
                  <VSelect
                    v-model="productData.tags"
                    :options="tags"
                    :reduce="optionReducer"
                    :get-option-label="getTagLabel"
                    multiple
                    label="name"
                  />
                  <p v-if="failed" class="msg error">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>
            </div>
            <div class="space-x-2 text-right">
              <button
                type="button"
                :disabled="updating"
                class="btn btn-brand style-link px-6"
                @click="closeModal"
              >
                Cancel
              </button>
              <button type="submit" :disabled="updating || invalid" class="btn btn-brand px-6">
                Submit
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Ui/Modal.vue';

export default {
  name: 'EditProductModal',
  components: {
    Modal,
  },
  props: {
    updating: Boolean,
    product: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    productData: {
      name: '',
      description: '',
      supplementaryDescription: '',
      url: '',
      price: 0,
      isBeta: false,
      requirements: null,
      categories: [],
      tags: [],
      producesModelType: null,
    },
  }),
  computed: {
    producesRules() {
      return 'required|oneOf:pages,campaigns,channels,pipelines,contact-lists,automations,forms,media';
    },
  },
  mounted() {
    this.productData = { ...this.productData, ...this.product };
  },
  methods: {
    optionReducer(option) {
      return option.id;
    },
    getTagLabel({ name, category }) {
      if (category) {
        return `${category}/${name}`;
      }
      return name;
    },
    submit() {
      this.submitProductData();
    },
    submitProductData() {
      this.$emit('submit', { ...this.productData });
    },
    backToProducts() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="postcss">
.vs__dropdown-option--selected {
  @apply hidden;
}
</style>
